<template>
  <div :class="$style.reports">
    <div
      :class="$style.title"
    >
      <div :class="$style.title_icon">
        <svg-sprite
          :name="iconName"
          :size="24"
          :color="iconColor"
          type="regular"
        />
      </div>
      <div :class="$style.title_text">
        <div :class="$style.text">
          {{ locales(`${title}`) }}
        </div>
        <tooltip
          v-if="hasTooltip"
          :class="$style.tooltip"
          :content="locales(`reports_title_tooltip_${title}`)"
          :position="'top'"
          :interactive="true"
          :with-animation="false"
        >
          <template #body>
            <svg-sprite
              :class="$style.icon"
              name="info"
              :size="24"
              :style="{
                'margin-right': 0,
                'margin-left': 'auto',
                'color': '#191919'
              }"
            />
          </template>
        </tooltip>
      </div>
      <div :class="$style.close">
        <vgp-icon-button
          size="small"
          :icon="{ name:'close-1', type:'regular', size: 20 }"
          :colors="buttonColors"
          @onClick="clickClose"
        />
      </div>
    </div>
  </div>
</template>

<script>
import svgSprite from '$$vueCmp/VueIcon/svgSprite.vue';
import tooltip from '../../common/VueComponents/tooltips/tooltip.vue';
import vgpIconButton from '$$vueCmp/globalButton/withIcon/iconButton.vue';

export default {
  components: {
    svgSprite, tooltip, vgpIconButton,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    iconName: {
      type: String,
      required: false,
      default: 'report',
    },
    iconColor: {
      type: String,
      required: false,
      default: '#00564C',
    },
    hasTooltip: { type: Boolean, required: false, default: true },
  },
  data() {
    return {
      locales: __,
      buttonColors: {
        color: '#333333',
        labelColor: '#191919',
        activeColor: '#333333',
        hoverBg: '#F2F2F2',
        activeBg: '#D0E0F2',
      },
    };
  },

  methods: {
    clickClose() {
      this.$router.back();
    },
  },
};
</script>

<style module src='./../less/reportsMain.less'></style>
